export default __webpack_public_path__ + "static/media/ja4.95a64775.jpg";